export const SidebarIdPersonalSettings = 'PERSONAL_SETTINGS' as const;
